import React, { useContext } from 'react';
import OperationHistoryPageContainerComponent from './OperationHistoryPageContainer/OperationHistoryPageContainer.container';
import { I18nContext } from 'utils/I18n/context';

const OperationsHistoryPage = () => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.historyPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content finance">
                <OperationHistoryPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

export default OperationsHistoryPage;
